import { PageOptions } from '@graphcommerce/framer-next-pages'
import { ProductListDocument, ProductListQuery } from '@graphcommerce/magento-product'
import { StoreConfigDocument } from '@graphcommerce/magento-store'
import { GetStaticProps, LayoutHeader, MetaRobots, PageMeta } from '@graphcommerce/next-ui'
import { Typography } from '@mui/material'
import { LayoutNavigation, LayoutNavigationProps, RowProduct, RowRenderer } from '../components'
import { LayoutDocument } from '../components/Layout/Layout.gql'
import getRevalidateTime from '../constants'
import { DefaultPageDocument, DefaultPageQuery } from '../graphql/DefaultPage.gql'
import { graphqlSharedClient, graphqlSsrClient } from '../lib/graphql/graphqlSsrClient'

type Props = DefaultPageQuery & {
  latestList: ProductListQuery
  favoritesList: ProductListQuery
  swipableList: ProductListQuery
}
type RouteProps = { url: string }
type GetPageStaticProps = GetStaticProps<LayoutNavigationProps, Props, RouteProps>

function AboutUs(props: Props) {
  return (
    <>
      <Typography variant='h3' align='center' mt={2}>
        Chi siamo{' '}
      </Typography>
      <p
        style={{
          width: '90%',
          marginTop: '80px',
          marginBottom: '80px',
          maxWidth: '900px',
          margin: '0 auto',
          whiteSpace: 'pre-line',
        }}
      >
        Jodé è la linea di arredi per la casa, l’albergo e i locali pubblici che rappresenta la
        nuova sfida di JUMBOFFICE, azienda leader nell’arredamento aziendale da oltre 30 anni
        <br />
        <br />
        JODE’ è una nuova proposta rivolta a chi non ama la banalità e il conformismo.
        <br />
        <br />
        Nella gamma di prodotti JODE’ potrete trovare idee che risponderanno alle esigenze della
        vostra personalità, che trasferirete negli ambienti che volete arredare per la soddisfazione
        ed il benessere dei vostri ospiti.
        <br />
        <br />
        La nostra esperienza nell’arredare ambienti professionali è la massima garanzia per la
        nostra clientale che i prodotti proposti possano soddisfare tutte le esigenze estetiche e di
        qualità.
        <br />
        <br />
        Il nostro servizio puntuale e preciso e la nostra assistenza tecnica vi aiuteranno a
        risolvere tutte le vostre problematiche.
        <br />
        <br />
        JUMBOFFICE e JODE’ hanno la certificazione UNI EN ISO 9001-2008 garantita da Sincerit DNV.
        <span
          style={{
            fontWeight: 'bold',
          }}
        >
          {' '}
          Jumboffice S.r.l.
          <br />
        </span>
        <br />
        <img src='img/Istituzionale3_Jumboffice.jpg' />
        <div>
          <span
            style={{
              fontWeight: 'bold',
            }}
          >
            Sede Firenze:
            <br />
          </span>
          Via Vittorio Emanuele, 19
          <br />
          50041 Calenzano (Firenze)
          <br />
          Tel. 055.88324 Fax. 055.8879134
          <br />
          mail: <a href='mailto:info@jode.it'>info@jode.it</a>
          <br />
          Orario Estivo: Lun-Ven 9,00-13,00 14,30-19,00
          <br />
          Sab - chiuso
          <br />
          Orario Invernale: Lun-Ven 9,00-13,00 14,30-19,00
          <br />
          Sab - 9,00-13,00 (magazzino chiuso)
        </div>
        <br />
        <img src='img/facciata-jumbo-roma-vetrina-2022-02.jpg' />
        <div>
          <span
            style={{
              fontWeight: 'bold',
            }}
          >
            {' '}
            Sede Roma
            <br />
          </span>
          Via Tiburtina, 1010
          <br />
          Roma - (Uscita 13 GRA)
          <br />
          Tel. 0641228004
          <br />
          mail: <a href='mailto:info.roma@jumboffice.it'>info.roma@jumboffice.it</a>
          <br />
          ORARIO AL PUBBLICO: Lunedi - Venerdì 9,00 - 18 continuato
          <br />
          Sab - chiuso
          <br />
        </div>
      </p>
    </>
  )
}

AboutUs.pageOptions = {
  Layout: LayoutNavigation,
} as PageOptions

export default AboutUs

export const getStaticProps: GetPageStaticProps = async ({ locale }) => {
  const client = graphqlSharedClient(locale)
  const staticClient = graphqlSsrClient(locale)

  const conf = client.query({ query: StoreConfigDocument })
  const page = staticClient.query({ query: DefaultPageDocument, variables: { url: `page/home` } })
  const layout = staticClient.query({ query: LayoutDocument })

  // todo(paales): Remove when https://github.com/Urigo/graphql-mesh/issues/1257 is resolved
  const favoritesList = staticClient.query({
    query: ProductListDocument,
    variables: { pageSize: 8, filters: { category_uid: { eq: 'Mg==' } } },
  })

  const latestList = staticClient.query({
    query: ProductListDocument,
    variables: { pageSize: 8, filters: { category_uid: { eq: 'Mg==' } } },
  })

  const swipableList = staticClient.query({
    query: ProductListDocument,
    variables: { pageSize: 8, filters: { category_uid: { eq: 'Mg==' } } },
  })

  if (!(await page).data.pages?.[0]) return { notFound: true }

  const revalidate = getRevalidateTime()

  return {
    props: {
      ...(await page).data,
      ...(await layout).data,
      latestList: (await latestList).data,
      favoritesList: (await favoritesList).data,
      swipableList: (await swipableList).data,
      apolloState: await conf.then(() => client.cache.extract()),
    },
    revalidate,
  }
}
